<div class="modal fade" id="kt_modal_ship_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Ship' : 'Add Ship' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="shipForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Ship Name -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Ship Name</label>
              <input type="text" class="form-control form-control-solid" formControlName="name"
                placeholder="Enter ship name" [class.is-invalid]="name?.invalid && name?.touched" />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Ship name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Ship name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Ship ID -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Ship ID</label>
              <input type="text" class="form-control form-control-solid" formControlName="ship_id"
                placeholder="Auto-generated" [disabled]="true" />
              <div class="form-text text-muted">Ship ID will be auto-generated by the system</div>
            </div>

            <!-- Company -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Company</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="companySearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onCompanySearchInput($event)"
                  (focus)="onCompanyInputFocus()"
                  (blur)="onCompanyInputBlur()"
                  placeholder="Search shipping companies..."
                  autocomplete="off"
                  [class.is-invalid]="company?.invalid && company?.touched"
                />

                <!-- Loading indicator -->
                <div *ngIf="isCompanySearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Company Dropdown -->
                <div *ngIf="showCompanyDropdown"
                  class="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                  style="z-index: 1050; max-height: 250px; overflow-y: auto;">
                  <div *ngIf="isCompanySearching" class="p-3 text-center">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching companies...
                  </div>
                  <div *ngIf="!isCompanySearching && companySearchResults.length === 0"
                    class="p-3 text-center text-muted">
                    No companies found
                  </div>
                  <div *ngFor="let company of companySearchResults"
                    class="p-3 cursor-pointer hover-bg-light border-bottom"
                    style="cursor: pointer;"
                    (mousedown)="selectCompany(company)">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <div class="fw-semibold">{{ company.company_name }}</div>
                        <div class="text-muted fs-8" *ngIf="company.email">
                          {{ company.email }}
                        </div>
                        <div class="text-muted fs-8" *ngIf="company.telephone">
                          {{ company.telephone }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="company?.invalid && company?.touched" class="invalid-feedback d-block">
                <div *ngIf="company?.errors?.['required']">Company is required</div>
              </div>
            </div>

            <!-- Voyage Number -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Voyage Number</label>
              <input type="text" class="form-control form-control-solid" formControlName="voyage_no"
                placeholder="Enter voyage number" [class.is-invalid]="voyage_no?.invalid && voyage_no?.touched" />
              <div *ngIf="voyage_no?.invalid && voyage_no?.touched" class="invalid-feedback">
                <div *ngIf="voyage_no?.errors?.['required']">Voyage number is required</div>
              </div>
            </div>

            <!-- Sailing Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Sailing Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="sailing_date"
                [class.is-invalid]="sailing_date?.invalid && sailing_date?.touched" />
              <div *ngIf="sailing_date?.invalid && sailing_date?.touched" class="invalid-feedback">
                <div *ngIf="sailing_date?.errors?.['required']">Sailing date is required</div>
              </div>
            </div>

            <!-- Sailing Port -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Sailing Port</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="sailingPortSearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onSailingPortSearch($event)"
                  (focus)="onSailingPortFocus()" (blur)="onSailingPortBlur()"
                  placeholder="Search and select sailing port..." autocomplete="off"
                  [class.is-invalid]="sailing_port?.invalid && sailing_port?.touched"
                  [disabled]="isLoadingSailingPorts" />

                <!-- Clear button -->
                <span *ngIf="selectedSailingPort" class="position-absolute end-0 top-50 translate-middle-y me-3"
                  style="cursor: pointer; z-index: 10;" (click)="clearSailingPort()">
                  <i class="ki-duotone ki-cross fs-4 text-gray-500">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>

                <!-- Sailing Port Dropdown -->
                <div *ngIf="showSailingPortDropdown"
                  class="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                  style="z-index: 1050; max-height: 250px; overflow-y: auto;">
                  <div *ngIf="isLoadingSailingPorts" class="p-3 text-center">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Loading ports...
                  </div>
                  <div *ngIf="!isLoadingSailingPorts && filteredSailingPortList.length === 0"
                    class="p-3 text-center text-muted">
                    No ports found
                  </div>
                  <div *ngFor="let port of filteredSailingPortList"
                    class="p-2 cursor-pointer hover-bg-light border-bottom" style="cursor: pointer;"
                    (mousedown)="selectSailingPort(port)">
                    <span class="fw-semibold">{{ port.name }}</span>
                    <span *ngIf="port.country" class="text-muted ms-2 small">{{ port.country.name }}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="sailing_port?.invalid && sailing_port?.touched" class="invalid-feedback d-block">
                <div *ngIf="sailing_port?.errors?.['required']">Sailing port is required</div>
              </div>
            </div>


            <!-- Destination Country -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Destination Country</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="countrySearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onCountrySearch($event)"
                  (focus)="onCountryFocus()"
                  (blur)="onCountryBlur()"
                  placeholder="Search and select country..."
                  autocomplete="off"
                  [class.is-invalid]="destination_country?.invalid && destination_country?.touched"
                />

                <!-- Clear button -->
                <span *ngIf="selectedDestinationCountry"
                      class="position-absolute end-0 top-50 translate-middle-y me-3"
                      style="cursor: pointer; z-index: 10;"
                      (click)="clearCountry()">
                  <i class="ki-duotone ki-cross fs-4 text-gray-500">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>

                <!-- Country Dropdown -->
                <div *ngIf="showCountryDropdown"
                     class="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                     style="z-index: 1050; max-height: 250px; overflow-y: auto;">
                  <div *ngIf="filteredCountryList.length === 0"
                       class="p-3 text-center text-muted">
                    No countries found
                  </div>
                  <div *ngFor="let country of filteredCountryList"
                       class="p-2 cursor-pointer hover-bg-light border-bottom"
                       style="cursor: pointer;"
                       (mousedown)="selectCountry(country)">
                    <span class="fw-semibold">{{ country.name }}</span>
                    <!-- <span *ngIf="country.code" class="text-muted ms-2 small">({{ country.code }})</span> -->
                  </div>
                </div>
              </div>
              <div *ngIf="destination_country?.invalid && destination_country?.touched" class="invalid-feedback d-block">
                <div *ngIf="destination_country?.errors?.['required']">Destination country is required</div>
              </div>
            </div>

            <!-- Destination Port -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Destination Port</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="destinationPortSearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onDestinationPortSearch($event)"
                  (focus)="onDestinationPortFocus()" (blur)="onDestinationPortBlur()"
                  placeholder="Search and select destination port..." autocomplete="off"
                  [class.is-invalid]="destination_port?.invalid && destination_port?.touched"
                  [disabled]="!selectedDestinationCountry || isLoadingDestinationPorts" />

                <!-- Clear button -->
                <span *ngIf="selectedDestinationPort" class="position-absolute end-0 top-50 translate-middle-y me-3"
                  style="cursor: pointer; z-index: 10;" (click)="clearDestinationPort()">
                  <i class="ki-duotone ki-cross fs-4 text-gray-500">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>

                <!-- Destination Port Dropdown -->
                <div *ngIf="showDestinationPortDropdown"
                  class="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                  style="z-index: 1050; max-height: 250px; overflow-y: auto;">
                  <div *ngIf="isLoadingDestinationPorts" class="p-3 text-center">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Loading ports...
                  </div>
                  <div *ngIf="!isLoadingDestinationPorts && filteredDestinationPortList.length === 0"
                    class="p-3 text-center text-muted">
                    {{ !selectedDestinationCountry ? 'Please select a country first' : 'No ports found' }}
                  </div>
                  <div *ngFor="let port of filteredDestinationPortList"
                    class="p-2 cursor-pointer hover-bg-light border-bottom" style="cursor: pointer;"
                    (mousedown)="selectDestinationPort(port)">
                    <span class="fw-semibold">{{ port.name }}</span>
                    <span *ngIf="port.country" class="text-muted ms-2 small">{{ port.country.name }}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="destination_port?.invalid && destination_port?.touched" class="invalid-feedback d-block">
                <div *ngIf="destination_port?.errors?.['required']">Destination port is required</div>
              </div>
              <div *ngIf="!selectedDestinationCountry" class="form-text text-muted">
                Please select a destination country first
              </div>
            </div>



            <!-- Arrival Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Arrival Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="arrival_date"
                [class.is-invalid]="arrival_date?.invalid && arrival_date?.touched" />
              <div *ngIf="arrival_date?.invalid && arrival_date?.touched" class="invalid-feedback">
                <div *ngIf="arrival_date?.errors?.['required']">Arrival date is required</div>
              </div>
            </div>


          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal" [disabled]="isLoading">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update Ship' : 'Add Ship' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
